module.exports = __webpack_public_path__ + "static/media/pf32.a43571f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf32.png
// module id = 2664
// module chunks = 0